import { ReactNode, type JSX } from 'react'

import { useModal } from '@context/ModalsContext'

import { Grid } from '@ui/Layouts/Grid/Grid'
import { Body1 } from '@ui/Typography'
import { PageSection } from '@ui/components/PageSection'

import { useScrollToTop } from '@hooks/useScrollToTop'

import { ProductServiceModal } from '@shared/modals/ProductService.modal'

import styles from './Vendors.module.scss'

export type VendorType = {
  name?: string
  imageUrl?: string
  description?: ReactNode
  url?: string
  removed?: boolean
}

interface VendorsProps {
  vendors: VendorType[]
  title: string
}

export const Vendors = ({ vendors, title }: VendorsProps): JSX.Element => {
  useScrollToTop()
  const productServiceModal = useModal(ProductServiceModal)

  return (
    <>
      <PageSection title={title} />
      <Grid>
        {vendors?.map((platfomVendor) => (
          <div
            key={platfomVendor.name}
            onClick={() => productServiceModal.open({ data: platfomVendor })}
            className={styles.card}
          >
            <div className={styles.cardImage}>
              <img src={platfomVendor.imageUrl} alt={platfomVendor.name} />
            </div>
            <Body1 className={styles.title} medium>
              {platfomVendor.name}
            </Body1>
          </div>
        ))}
      </Grid>
    </>
  )
}
